import { IOption, IOptionGroup } from "../../components/analytics/interfaces";
import { PARAMETER_TYPE } from "../../components/analytics/components/table/interfaces";

export const reduceGroups = (groups: IOptionGroup[], { group = PARAMETER_TYPE.noGroup, ...rest }: IOption) => {
  const foundGroup = groups.find(g => g.group === group);
  if (!foundGroup) {
    groups.push({
      group,
      options: [rest],
    });
  } else {
    foundGroup.options.push(rest);
  }
  return groups;
};
